import { library, config } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { fad } from "@fortawesome/pro-duotone-svg-icons"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"

library.add(fab)
library.add(fal)
library.add(fad)
library.add(fas)

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.component("fa", FontAwesomeIcon)
})
